module.exports = __webpack_public_path__ + "img/脸型精修--自定义调节.209f5340.png";